import { render } from "./FirmwarePage.vue?vue&type=template&id=6e1a3729"
import script from "./FirmwarePage.vue?vue&type=script&lang=js"
export * from "./FirmwarePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/ProductManage/ConfigManagement/components/DashBoard/FirmwarePage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6e1a3729"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6e1a3729', __exports__)) {
    api.reload('6e1a3729', __exports__)
  }
  
  module.hot.accept("./FirmwarePage.vue?vue&type=template&id=6e1a3729", () => {
    api.rerender('6e1a3729', render)
  })

}


export default __exports__